import Vue from 'vue'

export const rightsEditorDialogs = Vue.observable({ items: [] })

let dialogSequence = 0

export function openRightsEditor(options = {}) {
  dialogSequence += 1
  const key = `rights-editor-${Date.now()}-${dialogSequence}`

  rightsEditorDialogs.items.push({
    key,
    params: {
      root: options.root || 'interface',
      target: options.target || 'all',
      id: options.id ?? null,
    },
    title: options.title || 'Gestion des droits',
    width: options.width || 1700,
    persistent: Boolean(options.persistent),
    onClosed: typeof options.onClosed === 'function' ? options.onClosed : null,
  })

  return key
}

export function closeRightsEditor(key, result = null) {
  const index = rightsEditorDialogs.items.findIndex(item => item.key === key)
  if (index === -1) return
  const [item] = rightsEditorDialogs.items.splice(index, 1)
  if (item.onClosed) item.onClosed(result)
}

export function rightsEditorLocation(options = {}) {
  const query = {
    root: options.root || 'interface',
    target: options.target || 'all',
  }
  if (options.id !== undefined && options.id !== null) query.id = options.id
  return { name: 'engine-rights-edit', query }
}
